<template>
	<div class="switch">
		<div ref="switch-container" :data-item-active="currentActiveItem" :class="containerClass" class="switch-container">
			<div v-if="label" class="switch-label" :class="{active: currentActiveItem === labelItem}">
				<p>{{label}}</p>
			</div>
			<div class="switch-slider"></div>
			<div class="row centered">
				<div v-for="(item, index) in items" class="switch-selector" :class="'option-'+index" @click="clickItem(index)"><p>{{ item }}</p></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppSwitchNewDesign",
	emits: ["switched"],
	data() {
		return {
			currentActiveItem: Number(this.activeItem),
		}
	},
	props: {
		activeItem: {type: Number, default: 0},
		autoSwitch: {type: Boolean, default: false},
		label: {type: String, default: ''},
		labelItem: {type: Number, default: null},
		items: {type: Array, required: true, validator(value) { return value.length > 1 && value.length < 5 && value.every(item => { return typeof item === 'string'; }); }},
	},
	methods: {
		clickItem(index) {
			if (this.currentActiveItem !== index) {
				this.currentActiveItem = index;
				this.$emit('switched', index);
			} else {
				if(this.autoSwitch) {
					this.currentActiveItem = index === 0 ? 1 : 0;
					this.$emit('switched', this.currentActiveItem);
				}
			}
		}
	},
	computed: {
		containerClass() {
			return 'elements'+this.items.length;
		}
	},
	watch: {
		activeItem(value) {
			this.currentActiveItem = value;
		}
	},
}
</script>

<style lang="scss" scoped>
.switch {
	@include centered;
	@include columnFlex;

	p {
		margin-bottom: 5px;
		text-align: left;
		font-size: 14px;
		line-height: 15px;
		padding: 0 10px;
		width: 100%;
		margin-right: auto;
	}
}

.switch-container {
	position: relative;
	display: inline-block;
	height: 39px;
	cursor: pointer;
	width: 100%;
	min-width: 160px;
	max-width: 408px;
	border-radius: 13px;
	border: 1px solid var(--color-primary);

	.switch-label {
		bottom: 0;
		left: -1px;
		width: calc(100% + 2px);
		height: 100%;
		position: absolute;
		border-radius: 13px;
		border-top-left-radius: 18px;
		border-top-right-radius: 18px;
		background: var(--color-primary);
		transition: height .5s $transition;

		&.active {
			height: calc(100% + 22px);
		}
		p {
			font-size: 10px;
			text-align: center;
			width: 100%;
			color: var(--color-secondary);
			margin: 3px 0;
		}
	}

	&.elements2 {
		width: 160px;
	}

	&.elements3 {
		width: 270px;
	}

	&.elements4 {
		width: 360px;
	}

	& * {
		@include noSelect;
	}

	.row {
		height: 100%;
		position: absolute;
		top: 0;
		padding: 0 4px;

		.switch-selector {
			display: flex;
			@include centered;
			height: 100%;
			width: 100px;

			p {
				color: var(--color-txt-2);
				z-index: 1;
				width: 100%;
				text-align: center;
				margin-bottom: 0;
			}
		}
	}

	.switch-slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--bg-0);
		-webkit-transition: .4s;
		transition: .4s;
		border-radius: 12px;

		&:before {
			position: absolute;
			content: "";
			height: 29px;
			width: 80px;
			left: 4px;
			top: 50%;
			transform: translateY(-50%);
			background-color: var(--color-primary);
			-webkit-transition: left .3s $transition;
			transition: left .3s $transition;
			border-radius: 11px;
		}
	}

	&[data-item-active="0"] {
		.row .switch-selector:nth-of-type(1) p {
			color: white;
		}
	}

	&[data-item-active="1"] {
		.row .switch-selector:nth-of-type(2) p {
			color: white;
		}
	}

	&[data-item-active="2"] {
		.row .switch-selector:nth-of-type(3) p {
			color: white;
		}
	}

	&[data-item-active="3"] {
		.row .switch-selector:nth-of-type(4) p {
			color: white;
		}
	}

	.switch-selector p {
		@include truncateString;
		transition: color .3s $transition;
	}

	&.elements2 {
		.switch-slider:before {
			width: calc((100% - 8px) / 2);
		}

		.switch-selector {
			width: 50%;
		}

		&[data-item-active="1"] .switch-slider:before {
			left: 50%;
		}
	}

	&.elements3 {
		.switch-slider:before {
			width: calc((100% - 8px) / 3);
		}

		.switch-selector {
			width: calc(100% / 3);
		}

		&[data-item-active="1"] .switch-slider:before {
			left: calc((100% / 3) + 2px);
		}

		&[data-item-active="2"] .switch-slider:before {
			left: calc((100% / 3 * 2) - 2px);
		}
	}

	&.elements4 {
		.switch-slider:before {
			width: calc((100% - 8px) / 4);
		}

		.switch-selector {
			width: 25%;
		}

		&[data-item-active="1"] .switch-slider:before {
			left: calc(25% + 2px);
		}

		&[data-item-active="2"] .switch-slider:before {
			left: 50%;
		}

		&[data-item-active="3"] .switch-slider:before {
			left: calc(75% - 2px);
		}
	}

	@media (max-width: 460px) {
		min-width: 168px;
		max-width: 328px;

		&.elements2 {
			width: 168px;
		}
		&.elements3 {
			width: 248px;
		}
		&.elements4 {
			width: 328px;
		}
		.switch-selector p {
			padding: 0 6px;
		}
	}

	@media (max-width: 300px) {
		min-width: 88px;
		max-width: 168px;

		&.elements2 {
			width: 88px;
		}
		&.elements3 {
			width: 128px;
		}
		&.elements4 {
			width: 168px;
		}
		.switch-selector p {
			font-size: 10px;
			padding: 0 4px;
		}
	}
}

</style>